export default "__VITE_ASSET__BcaMfnco__$_?format=webp__"